import { defineStore } from 'pinia';
import Cookies from 'js-cookie';
import { useSocketStore } from "@/stores/socketConnectionStore";
import { useCompanyStore } from '@/stores/companyStore'; // Импортируем хранилище компании

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    user: null,
    company: null,
    contact: null,
    early_access: null
  }),

  actions: {
    auth(user, token, company, contact = null, early_access = null) {
      const socketService = useSocketStore();

      this.token = token;
      this.user = user;
      this.company = company;
      this.contact = contact;
      this.early_access = early_access;

      this.saveToCookies();

      socketService.connect(token);
    },

    logout() {
      const socketService = useSocketStore();
      const companyStore = useCompanyStore(); // Получаем экземпляр хранилища компании

      this.token = null;
      this.user = null;
      this.company = null;
      this.contact = null;
      this.early_access = null;

      this.clearCookies();
      companyStore.clearCompany();
      socketService.disconnect();
    },

    saveToCookies() {
      Cookies.set('token', this.token);
      const userJSON = JSON.stringify(this.user);
      Cookies.set('user', userJSON);
      const companyJSON = JSON.stringify(this.company);
      Cookies.set('company', companyJSON);
      if(this.early_access) {
        const earlyAccessJSON = JSON.stringify(this.early_access);
        Cookies.set('early_access', earlyAccessJSON);
      }
      if(this.contact){
        const contactJSON = JSON.stringify(this.contact);
        Cookies.set('contact', contactJSON);
      }
    },

    clearCookies() {
      Cookies.remove('token');
      Cookies.remove('user');
      Cookies.remove('company');
      Cookies.remove('contact');
      Cookies.remove('early_access');
    },

    checkCookies() {
      const token = Cookies.get('token');
      const storedUser = Cookies.get('user');
      const storedCompany = Cookies.get('company');
      const storedContact = Cookies.get('contact');
      const storedEarlyAccess = Cookies.get('early_access');

      if (token && storedUser && storedCompany) {
        const user = JSON.parse(storedUser);
        const company = JSON.parse(storedCompany);
        let contact = null;
        let early_access = null;
        if(storedContact) contact = JSON.parse(storedContact);
        if(storedEarlyAccess) early_access = JSON.parse(storedEarlyAccess);

        this.auth(user, token, company, contact, early_access);
      }
    },
  },

  getters: {
    isActiveUser() {
      return this.user && this.token && this.company;
    }
  }
});